import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-holland',
  templateUrl: './holland.component.html',
  styleUrls: ['./holland.component.css']
})
export class HollandComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/AnnaNorbisrath/WebstormProjects/me.rainer.surfschule-wiesensee/src/app/holland/holland.component.ts